import { Grid, SxProps, Theme } from "@mui/material";

type AccordionContentProps = {
  children: React.ReactNode;
  showDetails: boolean;
  sx?: SxProps<Theme>;
};

export function AccordionContent({
  children,
  showDetails,
  sx,
}: AccordionContentProps) {
  return showDetails ? (
    <Grid item sx={{ marginTop: "8px", padding: "4px", ...sx }} xs={12}>
      {children}
    </Grid>
  ) : (
    <></>
  );
}
